module.exports = __webpack_public_path__ + "img/lqsxback_3.9098656f.svg";